export const data = [
{
    question: "What is React?",
    option1: "A JavaScript library for building user interfaces",
    option2: "A database management system",
    option3: "A CSS framework",
    option4: "A web server",
    ans: 1,
},
{
    question: "Which method is used to create components in React?",
    option1: "createComponent()",
    option2: "React.component()",
    option3: "function or class",
    option4: "makeComponent()",
    ans: 3,
},
{
    question: "What is JSX?",
    option1: "A JavaScript extension",
    option2: "A syntax extension for JavaScript",
    option3: "A new programming language",
    option4: "A CSS preprocessor",
    ans: 2,
},
{
    question: "Which hook is used to manage state in functional components?",
    option1: "useEffect",
    option2: "useContext",
    option3: "useState",
    option4: "useReducer",
    ans: 3,
},
{
    question: "What does props stand for in React?",
    option1: "Properties",
    option2: "Prototypes",
    option3: "Proposals",
    option4: "Programs",
    ans: 1,
},
{
    question: "Which company developed React?",
    option1: "Google",
    option2: "Facebook (Meta)",
    option3: "Amazon",
    option4: "Microsoft",
    ans: 2,
},
{
    question: "What is the virtual DOM?",
    option1: "A physical copy of the DOM",
    option2: "A lightweight copy of the real DOM",
    option3: "A database",
    option4: "A server",
    ans: 2,
},
{
    question: "Which hook is used for side effects in React?",
    option1: "useState",
    option2: "useEffect",
    option3: "useProps",
    option4: "useRender",
    ans: 2,
},
{
    question: "What is the correct way to update state in React?",
    option1: "Directly modify the state variable",
    option2: "Use the setState function or state setter",
    option3: "Change the props",
    option4: "Reload the page",
    ans: 2,
},
{
    question: "What is the extension of React component files?",
    option1: ".html",
    option2: ".js or .jsx",
    option3: ".css",
    option4: ".react",
    ans: 2,
},
];